import React, { createContext, useContext, useMemo } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';
import { getGoogleMapsApiKey, getGoogleMapsKeyIssue } from '../api/mapsConfig';
import { buildRobinhoodMapsLoaderOptions } from '../maps/googleMapsLoaderConfig';

const blockedValue = { isLoaded: false, loadError: null, mapsBlocked: true };

const GoogleMapsContext = createContext(blockedValue);

function GoogleMapsLoaderProvider({ apiKey, children }) {
  const loaderOptions = useMemo(
    () => buildRobinhoodMapsLoaderOptions(apiKey),
    [apiKey]
  );

  const loader = useJsApiLoader(loaderOptions);

  const value = useMemo(
    () => ({
      isLoaded: loader.isLoaded,
      loadError: loader.loadError,
      mapsBlocked: false,
    }),
    [loader.isLoaded, loader.loadError]
  );

  return (
    <GoogleMapsContext.Provider value={value}>
      {children}
    </GoogleMapsContext.Provider>
  );
}

/** One Maps script load for the whole app (GOVOPS-1105). */
export function GoogleMapsProvider({ children }) {
  const issue = getGoogleMapsKeyIssue();
  const apiKey = getGoogleMapsApiKey();

  if (issue || !apiKey) {
    return (
      <GoogleMapsContext.Provider value={blockedValue}>
        {children}
      </GoogleMapsContext.Provider>
    );
  }

  return (
    <GoogleMapsLoaderProvider apiKey={apiKey}>
      {children}
    </GoogleMapsLoaderProvider>
  );
}

export function useRobinhoodGoogleMaps() {
  return useContext(GoogleMapsContext);
}
